import request, { requestV2 } from 'store/common/utils';
export const getDistrictsApi = (params) => request({
    url: '/districts',
    method: 'GET',
    params,
});
export const createDistrictApi = (data) => request({
    url: '/districts',
    method: 'POST',
    data,
});
export const editDistrictApi = (data) => request({
    url: `/districts/${data.id}`,
    method: 'PUT',
    data,
});
export const deleteDistrictApi = (data) => request({
    url: `/districts/${data.id}`,
    method: 'DELETE',
});
export const getDistrictAdminApi = (id) => request({
    url: `/districts/${id}`,
    method: 'GET',
});
export const getDistrictApi = ({ id, params }) => requestV2({
    url: `/districts/${id}`,
    method: 'GET',
    params,
});
export const getDistrictDevelopersApi = ({ districtId }) => request({
    url: `/districts/${districtId}/developers`,
    method: 'GET',
});
export const getDistrictImagesApi = ({ districtId }) => request({
    url: `/districts/${districtId}/images`,
    method: 'GET',
});
export const getDistrictCompaniesAggregate = (districtId, params) => request({
    url: `/districts/${districtId}/companies-aggregate`,
    method: 'GET',
    params,
});
